import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonModule } from 'primeng/button'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { DropdownModule } from 'primeng/dropdown'
import { MultiSelectModule } from 'primeng/multiselect'
import { InputTextModule } from 'primeng/inputtext'
import { CheckboxModule } from 'primeng/checkbox'
import { CalendarModule } from 'primeng/calendar'
import { TabViewModule } from 'primeng/tabview'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { EditorModule } from 'primeng/editor'
import { TableModule } from 'primeng/table'
import { FileUploadModule } from 'primeng/fileupload'
import { DialogModule } from 'primeng/dialog'
import { ListboxModule } from 'primeng/listbox'
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component'
import { MessagesModule } from 'primeng/messages'
import { MessageModule } from 'primeng/message'
import { AttachmentListComponent } from './components/attachment-list/attachment-list.component'
import { FileSaverModule } from 'ngx-filesaver'
import { PickListModule } from 'primeng/picklist'
import { NotificationService } from './services/notification.service'
import { NgxPermissionsModule } from 'ngx-permissions'
import { PermissionsModule } from './modules/permissions/permissions.module'
import { IconPickerModule } from 'ngx-icon-picker'
import { PanelModule } from 'primeng/panel'
import { AceModule } from 'ngx-ace-wrapper'
import { TooltipModule } from 'primeng/tooltip'
import { RouterModule } from '@angular/router'
import { PasswordInputComponent } from './components/password-input/password-input.component'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { KeyFilterModule } from 'primeng/keyfilter'
import { ConfirmationService, MessageService, SharedModule } from 'primeng/api'
import { DialogService } from 'primeng/dynamicdialog'
import { TreeTableModule } from 'primeng/treetable'
import { CatalogueChooserDialogComponent } from './components/catalogue-chooser-dialog/catalogue-chooser-dialog.component'
import { RoleManagementComponent } from './components/role-management/role-management.component'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DiagramsModule } from './modules/diagrams/diagrams.module'
import { DTOConfigEditorComponent } from './components/dtoconfig-editor/dtoconfig-editor.component'
import { ScriptActionsComponent } from './modules/action-module/components/script-actions/script-actions.component'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { ScriptResultComponent } from './modules/action-module/components/script-result/script-result.component'
import { AppConfigService } from './app-config/app-config.service'
import { JmlLibConfig } from './jml-lib-config'
import { JML_LIB_CONFIG } from './jml-lib-config.token'
import { ToastModule } from 'primeng/toast'
import { NotificationsComponent } from './components/notifications/notifications.component'
import { AppMenuModule } from './modules/app-menu/app-menu.module'
import { CardModule } from 'primeng/card'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { EntityStoreAccessModule } from './modules/entity-store-access/entity-store-access.module'
import { NotFoundComponent } from './components/not-found/not-found.component'
import { DynRouteInitComponent } from './components/dyn-route-init/dyn-route-init.component'
import { DashboardModule } from './modules/dashboard/dashboard.module'
import { DtoModule } from './modules/dto/dto.module'
import { ActionModule } from './modules/action-module/action.module'
import { UserProfileComponent } from './components/user-profile/user-profile.component'
import { LicenseUploadDialogComponent } from './components/license-upload-dialog/license-upload-dialog.component'
import { RxStompService } from './app-config/rx-stomp.service'
import { DirectivesModule } from './modules/directives/directives.module'
import { BytesToMBPipe } from './components/file-upload-dialog/bytes-to-mb.pipe'
import { SharedComponentsModule } from './modules/shared-components-module/shared.components.module'

export function initializeApp(appConfig: AppConfigService) {
  console.log('initialize app')
  return () => appConfig.load()
}

@NgModule({
  declarations: [
    FileUploadDialogComponent,
    AttachmentListComponent,
    PasswordInputComponent,
    CatalogueChooserDialogComponent,
    RoleManagementComponent,
    ScriptResultComponent,
    ScriptActionsComponent,
    DTOConfigEditorComponent,
    NotificationsComponent,
    NotFoundComponent,
    DynRouteInitComponent,
    UserProfileComponent,
    LicenseUploadDialogComponent,
    BytesToMBPipe
  ],
  imports: [
    AceModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CheckboxModule,
    CommonModule,
    ConfirmDialogModule,
    DiagramsModule,
    DialogModule,
    DropdownModule,
    EditorModule,
    FileSaverModule,
    FileUploadModule,
    FormsModule,
    IconPickerModule,
    InputTextModule,
    InputTextareaModule,
    KeyFilterModule,
    ListboxModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    NgxPermissionsModule.forChild({
      permissionsIsolate: false,
      rolesIsolate: false
    }),
    OverlayPanelModule,
    PanelModule,
    PermissionsModule,
    PickListModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollPanelModule,
    TabViewModule,
    TableModule,
    ToggleButtonModule,
    TooltipModule,
    TreeTableModule,
    ToastModule,
    AppMenuModule,
    EntityStoreAccessModule,
    DashboardModule,
    DtoModule,
    ActionModule,
    DirectivesModule,
    SharedComponentsModule
  ],
  exports: [
    FileUploadDialogComponent,
    AttachmentListComponent,
    NgxPermissionsModule,
    PermissionsModule,
    PasswordInputComponent,
    ScriptResultComponent,
    ProgressSpinnerModule,
    NotificationsComponent,
    EntityStoreAccessModule,
    LicenseUploadDialogComponent
  ],
  providers: [
    NotificationService,
    MessageService,
    DialogService,
    ConfirmationService,
    DynamicDialogConfig,
    DynamicDialogRef,
    RxStompService
    // { provide: RxStompService, useFactory: rxStompServiceFactory }
  ]
})
export class JmlLibModule {
  static forRoot(jmlLibConfig: JmlLibConfig): ModuleWithProviders<JmlLibModule> {
    console.log('initializing JmlLibModule (forRoot):', jmlLibConfig)
    return {
      ngModule: JmlLibModule,
      providers: [
        {
          provide: JML_LIB_CONFIG,
          useValue: jmlLibConfig
        },
        AppConfigService,
        { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true }
      ]
    }
  }
}
